import { MetaData, OrganisationUserRoles } from "@qid/core";
import { NotificationPreference } from "@qid/core";
import { User } from "../../user";
import { Organisation } from "../../organisation";

export class OrganisationUser extends MetaData {

  _id: any;
  user: User;
  organisation: Organisation;
  permissions: string[] = [];
  permissionsListName: string;
  role: OrganisationUserRoles;
  notificationPreferences: NotificationPreference[];
  /** Zoho Books ledger account_id — enables Cash on Create Order when set (master users). */
  zohoPaymentAccountId?: string | null;

}
